import LoadingIcon from '@/assets/svgs/loading.svg?react';
import { cn } from '@/lib/utils';

export const Loading = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <LoadingIcon
      {...props}
      className={cn('text-default animate-spin', props.className)}
    />
  );
};

export default Loading;
